import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { classNames } from '../../utils';

function SearchCard({
  Author,
  Type,
  Title,
  Link,
  Thumb,
  OverlayImage,
  Description,
  PublishedDate,
  PublishedDateText,
  Breadcumbs,
  Prices,
  isLocked,
  isVideo,
  ProductImageFlags
}) {
  const id = useId();

  return (
    <article className="search-listing-card" aria-labelledby={`search-${id}`}>
      {Thumb?.Src ? (
        <div
          className={classNames(
            `picture search-listing-card__image ${
              OverlayImage ? 'picture--has-badge' : ''
            }`,
            isVideo && 'search-listing-card__image--video'
          )}
        >
          {OverlayImage && OverlayImage.Src ? (
            <div
              className={`picture__badge picture__badge--${OverlayImage.Position}`}
            >
              <img src={OverlayImage.Src} alt={Thumb.Alt} />
            </div>
          ) : null}
          <picture>
            <img
              width={500}
              height={280}
              src={Thumb.Src}
              alt={Thumb?.Alt}
              loading="lazy"
            />
          </picture>
          {ProductImageFlags && ProductImageFlags.length > 0 && (
            <div className="product-card__flag">
              {ProductImageFlags.map((flag, index) => (
                <span
                  key={index}
                  className={classNames(
                    'product-card__flag-item',
                    flag?.FlagDark === true && 'product-card__flag-item--dark'
                  )}
                  style={{
                    '--flag-color': flag?.FlagColor,
                    backgroundColor: flag?.FlagColor
                  }}
                >
                  {flag?.FlagText}
                </span>
              ))}
            </div>
          )}
        </div>
      ) : null}
      <div className="search-listing-card__content">
        <span className="search-listing-card__type">{Type}</span>
        <h3 id={`search-${id}`} className="search-listing-card__title">
          <a
            href={Link}
            className={classNames(isLocked && 'locked')}
            dangerouslySetInnerHTML={{
              __html: `${Title} ${isLocked ? '<span></span>' : ''}`
            }}
          />
        </h3>
        {Author ? (
          <p>
            <em>{Author}</em>
          </p>
        ) : null}
        <time dateTime={PublishedDate}>{PublishedDateText}</time>
        <p dangerouslySetInnerHTML={{ __html: Description }} />
        {Prices ? (
          <div className="search-listing-card__prices">
            <strong className="search-listing-card__prices-member">
              {Prices.MemberPriceLabel} {Prices.MemberPrice}
            </strong>
            {Prices.NonMemberPrice && Prices.NonMemberPriceLabel ? (
              <strong>
                {Prices.NonMemberPriceLabel} {Prices.NonMemberPrice}
              </strong>
            ) : null}
            {Prices.AdditionalPrices?.map((price, index) => (
              <strong key={index}>
                {price.Label} {price.Price}
              </strong>
            ))}
          </div>
        ) : null}

        {Breadcumbs?.length ? (
          <nav
            aria-label={`${Title} Breadcrumbs`}
            className="search-listing-card__breadcrumbs"
          >
            <ul role="list">
              {Breadcumbs.map((breadcrumb, index) => (
                <li key={index}>
                  <a href={breadcrumb.Link}>{breadcrumb.Title}</a>
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
      </div>
    </article>
  );
}

SearchCard.propTypes = {
  Author: PropTypes.string.isRequired,
  Type: PropTypes.string.isRequired,
  Title: PropTypes.string.isRequired,
  Link: PropTypes.string.isRequired,
  Thumb: PropTypes.shape({
    Src: PropTypes.string.isRequired,
    Alt: PropTypes.string.isRequired
  }),
  OverlayImage: PropTypes.shape({
    Src: PropTypes.string.isRequired,
    Position: PropTypes.string.isRequired
  }),
  Description: PropTypes.string.isRequired,
  PublishedDate: PropTypes.string.isRequired,
  PublishedDateText: PropTypes.string.isRequired,
  isLocked: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(null)]),
  isVideo: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(null)]),
  Breadcumbs: PropTypes.arrayOf(
    PropTypes.shape({
      Title: PropTypes.string.isRequired,
      Link: PropTypes.string.isRequired
    })
  ),
  Prices: PropTypes.shape({
    MemberPrice: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(null)
    ]),
    MemberPriceLabel: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(null)
    ]),
    NonMemberPrice: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(null)
    ]),
    NonMemberPriceLabel: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(null)
    ]),
    AdditionalPrices: PropTypes.arrayOf(
      PropTypes.shape({
        Label: PropTypes.string.isRequired,
        Price: PropTypes.string.isRequired
      })
    )
  }),
  ProductImageFlags: PropTypes.array
};

export default SearchCard;
